import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PackageCategory, PackageCategoryWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePackageCategory(): UseMutationResult<
  AxiosResponse<PackageCategory>,
  AxiosError<ErrorMessage>,
  PackageCategoryWrite
> {
  const queryClient = useQueryClient();

  const updatePackageCategory = useCallback(
    (packageCategory: PackageCategoryWrite): Promise<AxiosResponse<PackageCategory>> => {
      return client.put(`package-categories/${packageCategory.packageCategoryId}/`, packageCategory);
    },
    [],
  );
  return useMutation(updatePackageCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('packageCategories');
      queryClient.invalidateQueries('packages');
    },
  });
}
